import { getDatabase } from 'firebase/database'
import { initializeFirestore } from 'firebase/firestore'
import { app } from '../app'
export const realtimeDb = getDatabase(app)
export const db = initializeFirestore(app, {
  ignoreUndefinedProperties: true,
})
